import { createVirtualLink } from '../../../../util/createVirtualLink';
import { ACTIONS } from '../Constants';

/**
 * @name handleAction - Handles actions based on action defined in strapi
 * @param {string} action - Action type to perform
 * @param {string} redirectUrl - Redirection URl provided in strapi for specfic action
 * @param  {Array} states -Handles states passed from parent
 */
const handleAction = async (action, redirectUrl, ...states) => {
  const { GENERIC_REDIRECT, GENERIC_CALL_DIALER } = ACTIONS;
  const [router] = states;

  switch (action) {
    case GENERIC_REDIRECT:
      createVirtualLink(redirectUrl);
      break;
    case GENERIC_CALL_DIALER:
      router.push(`tel:${redirectUrl}`);
      break;
    default:
      console.log('error', 'Unhandled action', action);
      break;
  }
};

export default handleAction;
